import React from 'react'

function Loader() {
  return (
    <div className='fc-loader'>
      <div className='spinner-border' style={{ color: 'var(--teal)', width: '2.5rem', height: '2.5rem' }} role='status'>
        <span className='visually-hidden'>Loading...</span>
      </div>
    </div>
  )
}

export default Loader
